module.exports = __webpack_public_path__ + "img/icon1.f1f39953.png";